import { fromJS } from 'immutable'
import {
  TIMESHEET_REQUEST_GET_REQUEST,
  TIMESHEET_REQUEST_GET_SUCCESS,
  TIMESHEET_REQUEST_GET_FAILURE,
  TIMESHEET_REQUEST_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_REQUEST_GET_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_REQUEST_GET_SUCCESS:
      return state
        .set('timesheetRequest', fromJS(action.payload))
        .set('isFetching', false)
    case TIMESHEET_REQUEST_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case TIMESHEET_REQUEST_GET_RESET:
      return state
        .delete('timesheetRequest')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-request-get-reducer.js